export default "__VITE_ASSET__Cmhlr2qs__"